import FileHelper from "@/helpers/utilities/FileHelper";

/**
 * Skobo Submission class representing a Teams submission resource (eg files or links)
 *
 * @category Models
 * @subcategory Education
 * @class Education
 * @name SubmissionResource
 */
class SubmissionResource {
  id = "";
  assignmentResourceUrl = "";

  resource = {
    "@odata.type": "",
    displayName: "",
    link: "",
    fileUrl: null
  };

  // Skbo Specific
  isDirty = false;
  driveId = null;
  itemId = null;
  extension = null;

  constructor(graphFile) {
    if (graphFile) {
      if (graphFile.id) {
        this.itemId = graphFile.id;
      }

      if (graphFile.name) {
        this.resource.displayName = graphFile.name;
        this.extension = FileHelper.getFileExtensionObject(graphFile.name);
        this.resource["@odata.type"] = FileHelper.getFileOdataType(this.extension.type);
      }

      if (graphFile.file && graphFile.file.mimeType) {
        this.resource["@odata.type"] = FileHelper.getFileOdataType(graphFile.file.mimeType);
      }

      if (graphFile.parentReference) {
        this.driveId = graphFile.parentReference.driveId;
      }
    }
  }

  // Getters
  /**
   * Indicates if resource is a file
   *
   * @returns {boolean} True if resource is a file
   */
  get isFileResource() {
    return (!!this.resource.fileUrl && this.resource.fileUrl !== "") || (!!this.driveId && !!this.itemId);
  }

  /**
   * Indicates whether resource is distributed from assignment
   *
   * @returns {boolean} True if resource is distributed from an assignment (attached to assignment by teacher and student will get copy to hand in)
   */
  get isFileDistributedFromAssignment() {
    return !!this.assignmentResourceUrl;
  }

  get unique() {
    if (this.id && this.id.length > 0) {
      return this.id;
    } else {
      return this.tempId;
    }
  }

  // Static Methods
  /**
   * Parse submission resource from Graph Api to skobo
   *
   * @param {object} graphSubmissionResource  Resource from graph api
   * @returns { object } Same resource object but parsed depending on being file or link
   */
  static parseFromGraph(graphSubmissionResource) {
    const resource = Object.assign(new SubmissionResource(), graphSubmissionResource);

    if (resource.isFileResource) {
      resource.extension = FileHelper.getFileExtensionObject(resource.resource.displayName);
    } else {
      resource.extension = FileHelper.getLinkTemplate();
    }
    return resource;
  }
}

export default SubmissionResource;
